import React, { useId } from "react";

const Textarea = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  rows = 4,
  required = false,
  error,
  disabled = false,
  maxLength,
  showCount = false,
  className = "",
}) => {
  const generatedId = useId();
  const textareaId = name || generatedId;
  const errorId = `${textareaId}-error`;
  const countId = `${textareaId}-count`;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={textareaId}
          className="block text-sm font-medium text-gray-900 mb-1"
        >
          {label}
          {required && (
            <span className="text-red-700 ml-1" aria-hidden="true">
              *
            </span>
          )}
          {required && <span className="sr-only"> (required)</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        maxLength={maxLength}
        required={required}
        aria-required={required || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={
          [error ? errorId : null, showCount && maxLength ? countId : null]
            .filter(Boolean)
            .join(" ") || undefined
        }
        className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-blue focus:border-transparent resize-vertical ${
          error ? "border-red-700" : ""
        } ${disabled ? "bg-gray-100 cursor-not-allowed" : ""} ${className}`}
      />
      <div className="flex justify-between items-center mt-1">
        {error && (
          <p id={errorId} className="text-sm text-red-700" role="alert">
            {error}
          </p>
        )}
        {showCount && maxLength && (
          <p id={countId} className="text-xs text-gray-700 ml-auto">
            {value?.length || 0}/{maxLength}
          </p>
        )}
      </div>
    </div>
  );
};

export default Textarea;
